var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"h2"},[_vm._v("Words")]),_c('word-list',{attrs:{"word-ids":_vm.componentData.content.words,"milestone-id":_vm.componentData.content.milestone}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }